import React from 'react';
import { LucideIcon } from 'lucide-react';
import Button from './Button';
import { neutralColors } from '../../styles/colors';

interface EmptyStateProps {
  icon?: LucideIcon;
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
  className?: string;
}

/**
 * Actionable empty state for list pages (leads, projects, messages, finances).
 * Keep copy short: one title, one sentence, one CTA.
 */
const EmptyState: React.FC<EmptyStateProps> = ({
  icon: Icon,
  title,
  description,
  actionLabel,
  onAction,
  className = '',
}) => {
  return (
    <div className={`text-center py-12 px-4 ${className}`}>
      {Icon && (
        <Icon className={`mx-auto h-12 w-12 ${neutralColors.grayTextLight} mb-4`} aria-hidden />
      )}
      <h3 className={`text-lg font-medium ${neutralColors.grayTextHover} mb-2`}>{title}</h3>
      <p className={`${neutralColors.grayTextLight} text-sm mb-6 max-w-sm mx-auto`}>{description}</p>
      {actionLabel && onAction && (
        <Button variant="primary" onClick={onAction}>
          {actionLabel}
        </Button>
      )}
    </div>
  );
};

export default EmptyState;
